export enum SplashScreenType {
  IMAGE = 'IMAGE',
  LOTTIE = 'LOTTIE',
}
